document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('bordado-input');
  if (!input) return;

  const form = document.querySelector('.product__form-buttons');
  const submitBtn = document.getElementById('addToCart');
  const ADDON_VARIANT_ID = 57446986842452;
  const dynamicCheckoutWrapper = document.getElementById('dynamic-checkout-wrapper');

  function toggleDynamicCheckout() {
    if (!dynamicCheckoutWrapper) return;
    dynamicCheckoutWrapper.style.display = input.value.trim().length > 0 ? 'none' : '';
  }

  input.addEventListener('input', toggleDynamicCheckout);
  toggleDynamicCheckout();

  // Lee la cantidad elegida por el cliente (selector visible de la ficha)
  function getQuantity(formData) {
    const qtyInput = document.querySelector('.js-qty-input');
    const raw = (qtyInput && qtyInput.value) || formData.get('quantity') || 1;
    const qty = parseInt(raw, 10);
    return qty > 0 ? qty : 1;
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', async function (e) {
      if (input.value.trim().length === 0) {
        return; // sin bordado, dejamos que el tema actúe normal
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const qty = getQuantity(formData);
        formData.set('quantity', qty); // el pijama se añade con la misma cantidad

        const res1 = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res1.ok) throw new Error('Error al añadir el pijama');

        const res2 = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: ADDON_VARIANT_ID, quantity: qty }] })
        });
        if (!res2.ok) throw new Error('Error al añadir el bordado');

        window.location.href = '/cart';
      } catch (err) {
        submitBtn.disabled = false;
        alert('Hubo un error al añadir el producto. Inténtalo de nuevo.');
      }
    }, true);
  }
});